/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { DEFAULT_ADVANCED } from "../../utils/types";
import type { ProjectSamplingDefaults } from "../../services/ttsService";
import type { IPartner } from "../../services/partnerService";

interface Props {
  partners: IPartner[];
  mode: 'create' | 'edit';
  initialName?: string;
  initialDescription?: string;
  onSave: (
    name: string,
    description: string,
    sampling: ProjectSamplingDefaults,
    partnerId: string | null,
  ) => void;
  onCancel: () => void;
}



const NewProjectModal: React.FC<Props> = ({ mode, initialName = "", initialDescription = "", partners, onSave, onCancel }) => {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);
  const [partnerId, setPartnerId] = useState("");
  const [temperature, setTemperature] = useState(DEFAULT_ADVANCED.temperature);
  const [topP, setTopP] = useState(DEFAULT_ADVANCED.topP);
  const [topK, setTopK] = useState(DEFAULT_ADVANCED.topK);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    // console.log("show name length",name.length); 
    
    onSave(
      name.trim(),
      description.trim(),
      {
        temperature: Number.isFinite(temperature) ? temperature : DEFAULT_ADVANCED.temperature,
        topP: Number.isFinite(topP) ? topP : DEFAULT_ADVANCED.topP,
        topK: Number.isFinite(topK) ? topK : DEFAULT_ADVANCED.topK,
      },
      partnerId || null,
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box modal-box--wide">
        <div className="modal-title">{mode === 'edit' ? 'Edit Project' : 'Create New Project'}</div>
        <div className="modal-sub">{mode === 'edit' ? 'Update the project name or description.' : 'A project is your top-level workspace containing multiple books.'}</div>

        <form onSubmit={handleSubmit}>
          <div className="cp-field">
            <div className="cp-field__label-row">
              <span className="cp-field__label">Project Name</span>
            </div>
            <input
              type="text" value={name} onChange={(e) => setName(e.target.value.slice(0, 100))}
              placeholder="e.g. Joan's Audiobook Studio" required autoFocus
            />
            <small style={{ color: name.length >= 100 ? '#ef4444' : '#9ca3af', fontSize: 11 }}>{name.length}/100</small>
          </div>

          <div className="cp-field">
            <div className="cp-field__label-row">
              <span className="cp-field__label">Description</span>
            </div>
            <input
              type="text" value={description} onChange={(e) => setDescription(e.target.value.slice(0, 500))}
              placeholder="Optional description"
            />
            <small style={{ color: description.length >= 500 ? '#ef4444' : '#9ca3af', fontSize: 11 }}>{description.length}/500</small>
          </div>
{mode !== 'edit' && (


          <div className="cp-field">
            <div className="cp-field__label-row">
              <span className="cp-field__label">Assign Partner</span>
            </div>
            <select value={partnerId} onChange={(e) => setPartnerId(e.target.value)}>
              <option value="">Unassigned (admin only)</option>
              {partners.filter((p) => p.active).map((p) => (
                <option key={p._id} value={p._id}>
                  {p.name} ({p.email})
                </option>
              ))}
            </select>
          </div>
          ) }
{/* 
          <div className="modal-grid-span">
            <div className="modal-sub" style={{ marginBottom: 12 }}>
              Default sampling for all new books in this project (each book can override later).
            </div>
            <div className="modal-adv-3col">
              <FormField label="Temperature" hint="0.01 – 2.0">
                <input
                  type="number"
                  value={temperature}
                  onChange={(e) => setTemperature(Number(e.target.value))}
                  min={0.01}
                  max={2}
                  step={0.01}
                />
              </FormField>
              <FormField label="Top-P" hint="0 – 1">
                <input
                  type="number"
                  value={topP}
                  onChange={(e) => setTopP(Number(e.target.value))}
                  min={0}
                  max={1}
                  step={0.01}
                />
              </FormField>
              <FormField label="Top-K" hint="1+">
                <input
                  type="number"
                  value={topK}
                  onChange={(e) => setTopK(Number(e.target.value))}
                  min={1}
                  step={1}
                />
              </FormField>
            </div>
          </div> */}

          <div className="modal-actions">
            <button type="button" className="modal-btn modal-btn--cancel" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="modal-btn modal-btn--save">
              {mode === 'edit' ? 'Save Changes' : 'Create Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewProjectModal;